import {Autocomplete, SxProps, TextField, Theme} from '@mui/material';
import {FC, useMemo} from 'react';
import {Control, Controller} from 'react-hook-form';
import {useDaData} from '../../../../hooks/useDaData';

type Props = {
  name: string;
  control: Control;
  label?: string;
  size?: 'small' | 'medium';
  disablePortal?: boolean;
  sx?: SxProps<Theme>;
};

export const DadataAddressField: FC<Props> = ({name, control, label, size, disablePortal, sx}) => {
  const {handleChangeAddress, suggestions} = useDaData();

  const options = useMemo(() => suggestions.map((s) => s.unrestricted_value), [suggestions]);

  const handleInputChange = (_: unknown, newValue: string) => {
    handleChangeAddress(newValue);
  };

  return (
    <Controller
      name={name}
      control={control}
      rules={{required: 'Обязательное поле'}}
      render={({field, fieldState}) => (
        <Autocomplete
          disablePortal={disablePortal}
          sx={sx}
          freeSolo
          size={size}
          options={options}
          value={field.value || ''}
          onChange={(_, newValue) => field.onChange(newValue)}
          filterOptions={(x) => x}
          onInputChange={handleInputChange}
          renderInput={(params) => (
            <TextField
              {...params}
              label={label}
              variant="outlined"
              error={!!fieldState.error}
              helperText={fieldState.error?.message}
            />
          )}
        />
      )}
    />
  );
};
